import * as PIXI from 'pixi.js'
import Tool from './tool.class'
import { clear } from '../utils'

export default class DrawShieldLine extends Tool {
  drawing = false
  start
  idxs = []
  shiftKey = false
  update(event, config, container, pixiObj, options, vm) {
    super.update(...arguments)
  }
  mouseDown(event) {
    this.start = event
    this.drawing = true
  }
  mouseUp(event) {
    if (this.drawing) {
      this.drawing = false
      this.sendResultData(event)
    }
  }
  mouseWheel(event) {}
  mouseMove(event) {
    this.shiftKey = event.shiftKey
    this.drawing &&
      this.draw(
        this.start.offsetX,
        this.start.offsetY,
        event.offsetX,
        event.offsetY,
      )
  }
  mouseLeave(event) {
    if (this.drawing) {
      this.drawing = false
      this.sendResultData(event)
    }
  }
  sendResultData(endEvent) {
    this.$msg({
      type: 'DRAW_SHIELD_LINE',
      delete: this.shiftKey,
      idxs: this.idxs,
    })
    clear(this.container)
  }
  draw(x1, y1, x2, y2) {
    clear(this.container)
    const options = this.options
    const rootOptions = options.rootOptions

    const cols = 60
    const box = rootOptions.box
    const blockWidth = (rootOptions.width - box.left - box.right) / cols
    const blockHeight = rootOptions.height - box.top - box.bottom

    const particleContainer = new PIXI.ParticleContainer(cols)
    this.container.addChild(particleContainer)

    const graphic = new PIXI.Graphics()
    const isDelete = this.shiftKey
    if (this.config.type === 'SHIELD_LINE') {
      if (isDelete) {
        graphic.beginFill(0xbcbcbc, 0.3)
        graphic.lineStyle(1, 0xbcbcbc, 1)
      } else {
        graphic.beginFill(0x18a689, 0.5)
        graphic.lineStyle(1, 0x18a689, 1)
      }
    } else if (this.config.type === 'SHIELD_LINE_TIME') {
      if (isDelete) {
        graphic.beginFill(0xbcbcbc, 0.3)
        graphic.lineStyle(1, 0xbcbcbc, 1)
      } else {
        graphic.beginFill(0x9acc5e, 0.5)
        graphic.lineStyle(1, 0x9acc5e, 1)
      }
    }
    graphic.drawRect(0, 0, blockWidth, blockHeight)
    const texture = this.pixiObj.renderer.generateTexture(graphic)

    this.idxs = this.getDrawLineIdxs(x1, x2, cols, options.width)
    this.idxs.forEach(i => {
      const row = Math.floor(i / cols)
      const col = i % cols
      const x = col * blockWidth
      const y = row * blockHeight + (Number(box.top) || 0)

      const rectangle = new PIXI.Sprite(texture)
      rectangle.x = x
      rectangle.y = y

      particleContainer.addChild(rectangle)
    })
  }
  getDrawLineIdxs(x1, x2, cols, width) {
    if (x1 > x2) {
      ;[x1, x2] = [x2, x1]
    }
    const blockWidth = width / cols
    const startIdxX = Math.floor(x1 / blockWidth)
    const endIdxX = Math.floor(x2 / blockWidth)

    const result = []
    let idxX = startIdxX
    while (true) {
      result.push(idxX++)
      if (idxX > endIdxX) {
        break
      }
    }
    return result
  }
}
